import { render, staticRenderFns } from "./DetailModal.vue?vue&type=template&id=054e9866&scoped=true"
import script from "./DetailModal.vue?vue&type=script&lang=js"
export * from "./DetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054e9866",
  null
  
)

export default component.exports